import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit,OnChanges {
  overlay: boolean = false;
  @Input() isExpand: boolean=true;
  @Input() forRestrictView:boolean;
  @Input() menuItems:Array<Object>;
  @Output() navEvent = new EventEmitter();
  constructor(public translate: TranslateService) {}

  ngOnInit() {
  }
  onChangeSideNav(){
    this.navEvent.emit({ event: "sidenavAction"});
  }
  ngOnChanges(){

  }
} 
